import posthog, { isPosthogConfigured } from "./posthog.js";

function info(message, attributes) {
  if (isPosthogConfigured) {
    posthog.captureLog({
      body: message,
      level: "info",
      ...(attributes && { attributes })
    });
  }
}

const posthogLogger = {
  productAddedToCart(variantId) {
    info("product added to cart", { variant_id: variantId });
  },

  checkoutStarted() {
    info("checkout started");
  },

  backInStockSubscriptionCreated(variantId) {
    info("back-in-stock subscription created", { variant_id: variantId });
  }
};

export default posthogLogger;
